module.exports = __webpack_public_path__ + "static/media/kols-newbanner.35e51bf2.webp";